import { WmsLayer } from "../WmsLayer";
import { AsbestosFeatureLayer } from "./Components/AsbestosFeatureLayer";
import { FilterAsbestosSusceptibility } from "./Components/FilterAsbestosSusceptibility";
// import { FilterAsbestosSusceptibility } from "./FilterAsbestosSusceptibility";

class AsbestosSusceptibilityLayer extends WmsLayer {
  constructor(layer_data, layer_group_id) {
    super(layer_data, layer_group_id);

    this.has_filter = true;

    this.getFilter = () => (
      <FilterAsbestosSusceptibility
        callback={this.callback_change_filter}
        filters={this.filters}
      />
    );

    this.id = this.id.replace(
      layer_data.uuid,
      `asbestos-susceptibility-${layer_data.uuid}`
    );
  }

  callback_change_filter = (new_filters) => {
    // document.addEventListener("update-filter-"+layerGroup.id,loadFeatures() )
    console.log("Cambiando filtros", this.layer);
    this.filters = new_filters;
    const new_source = this.createSource();

    this.layer.setSource(new_source);
    this.layer.getSource()?.updateParams({ t: Date.now() });
    console.log("Cambiando source", this.layer);
  };

  getFeatureComponent(feature) {
    return <AsbestosFeatureLayer feature={feature} key={this.id} />;
  }
}

export { AsbestosSusceptibilityLayer };
